import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Col, Row, Input } from 'reactstrap';
import { getCorprateUrl } from '../../../shared/components/domainSupport';
import { jsonHeader, serverUrl, isProdEnv } from '../../../config';
import LoadingSpinner from '../../../shared/components/widgets/LoadingSpinner';
import Alert from '../../../shared/components/Alert';

const CreateCustomer = () => {
  const user = useSelector(store => store.authentication.user);
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerDescription, setCustomerDescription] = useState('');
  const [customerMetadata, setCustomerMetadata] = useState('');
  const [loading, setLoading] = useState(false);
  const [localAlert, setLocalAlert] = useState({});

  const createCustomer = () => {
    setLoading(true);
    setLocalAlert({});
    const headerWithAuth = { ...jsonHeader, authorization: `JWT ${user?.jwtToken}` };
    // Add logic to check input values, make sure they are present and correct.
    if (customerName !== '' && customerEmail !== '') {
      const customerOptions = {
        method: 'POST',
        headers: headerWithAuth,
        body: JSON.stringify({
          name: customerName,
          email: customerEmail,
          description: customerDescription,
          metadata: customerMetadata,
        }),
      };

      const createCustomerUrl = `${serverUrl}/customers`;
      fetch(createCustomerUrl, customerOptions)
        .then(async (results) => {
          if (!results.ok) {
            const text = await results.text();
            throw new Error(text);
          }
          return results.json();
        }).then((data) => {
          if (!isProdEnv) {
            console.info(data);
          }

          const row = Array.isArray(data) ? data[0] : data;

          setLocalAlert({ color: 'primary', message: `Customer Created - CID: ${row.customer_id}, ECID: ${row.external_customer_id}` });
          setCustomerName('');
          setCustomerEmail('');
          setCustomerDescription('');
          setCustomerMetadata('');
        }).catch((error) => {
          setLocalAlert({ color: 'danger', message: JSON.stringify(error) });
          console.error(error);
        });
    } else {
      setLocalAlert({ color: 'danger', message: 'Please fill in required fields' });
    }
    setLoading(false);
  }

  return (
    <Col md={12}>
      <Card>
        <Row>
          <Col md={5}>
            <CardBody>
              <LoadingSpinner active={loading} />
              {!loading && (
                <>
                  <div className="form__form-group">
                    {localAlert && localAlert.message && (
                      <Alert color={localAlert.color}>{localAlert.message}</Alert>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Customer Name</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="customerName"
                        component="input"
                        type="text"
                        value={customerName}
                        onChange={(e) => setCustomerName(e.target.value)}
                        maxLength={255}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!customerName || customerName === '') && (
                      <div className="form__form-group-error">Customer Name is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Customer Email</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="customerEmail"
                        component="input"
                        type="text"
                        value={customerEmail}
                        onChange={(e) => setCustomerEmail(e.target.value)}
                        maxLength={255}
                      />
                    </div>
                    {localAlert.message && localAlert.color !== 'primary' && (!customerEmail || customerEmail === '') && (
                      <div className="form__form-group-error">Customer Email is required</div>
                    )}
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Customer Description</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="customerDescription"
                        component="input"
                        type="text"
                        value={customerDescription}
                        onChange={(e) => setCustomerDescription(e.target.value)}
                        maxLength={255}
                      />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">Customer Metadata</span>
                    <div className="form__form-group-field">
                      <Input
                        autoFocus
                        name="customerMetadata"
                        component="input"
                        type="text"
                        value={customerMetadata}
                        onChange={(e) => setCustomerMetadata(e.target.value)}
                        maxLength={255}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="form__form-group">
                    <button className="btn btn-primary customer__btn" type="submit" disabled={loading} onClick={() => createCustomer()}>Create Customer</button>
                  </div>
                </>
              )}
            </CardBody>
          </Col>
          <Col md={5}>
            <CardBody>
              <br />
              <p>PLEASE NOTE:<br /><br /></p>
              <blockquote><p>This will create a new customer, a customer can own multiple accounts</p></blockquote>
              <br />
              <blockquote><p>Please onboard accounts using this customer name and email</p></blockquote>
              <br />
              <blockquote><p>By Clicking &apos;Create Customer&apos;, you agree to our <a href={`${getCorprateUrl()}/terms-of-use`} rel="noopener noreferrer" target="_blank">Terms &amp; Conditions</a></p></blockquote>
              <br />
            </CardBody>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default CreateCustomer;
